import { useReducer } from 'react'
import rootReducer from '../reducers/rootReducer'
import { getInitialState } from '../utils/initialState'

function useStore() {
    return useReducer(rootReducer, getInitialState())
}

export default useStore